import React, { Children } from 'react';
import { Section } from '../components/ui/Section';
import { Button } from '../components/ui/Button';
import { CheckCircle, Sparkles, Brain, Heart, ExternalLink } from 'lucide-react';
export const StudentsProgram = () => {
  return <div className="pt-20" data-id="element-581">
      {/* Hero */}
      <div className="bg-[#F2F0E7] py-20 md:py-32" data-id="element-582">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-583">
          <div className="max-w-3xl" data-id="element-584">
            <div className="inline-block px-4 py-2 bg-white text-[#3AB5E8] rounded-full font-semibold text-sm mb-6 shadow-sm border-2 border-[#3AB5E8]/20" data-id="element-585">
              For Students
            </div>
            <h1 className="text-4xl md:text-6xl font-bold text-[#1C274C] mb-6 leading-tight" data-id="element-586">
              Project AI for <span className="text-[#3AB5E8]" data-id="element-587">Kids</span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-588">
              Project AI for Children introduces African children to Artificial
              Intelligence in a way that is fun, age-appropriate, ethical, and
              empowering.
            </p>
            <p className="text-lg text-gray-600 mb-8" data-id="element-589">
              This program focuses on helping children understand how AI works,
              where it shows up in everyday life, and how it can be used
              creatively to solve real problems.
            </p>
            <div className="flex gap-4" data-id="element-590">
              <a href="https://forms.gle/yiZQndnfYhzdQtX68" target="_blank" rel="noopener noreferrer" data-id="element-591">
                <Button size="lg" rightIcon={<ExternalLink className="w-5 h-5" data-id="element-593" />} data-id="element-592">
                  Join the Waitlist
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* What Children Learn */}
      <Section data-id="element-594">
        <div className="max-w-4xl mx-auto" data-id="element-595">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1C274C] mb-12 text-center" data-id="element-596">
            What Children Learn
          </h2>

          <div className="space-y-8" data-id="element-597">
            <div className="bg-white p-8 rounded-2xl border-2 border-[#3AB5E8]/20 shadow-sm" data-id="element-598">
              <div className="flex items-start gap-4" data-id="element-599">
                <div className="w-12 h-12 bg-[#3AB5E8]/10 rounded-full flex items-center justify-center shrink-0" data-id="element-600">
                  <Brain className="w-6 h-6 text-[#3AB5E8]" data-id="element-601" />
                </div>
                <div data-id="element-602">
                  <h3 className="text-xl font-bold text-[#1C274C] mb-2" data-id="element-603">
                    AI Foundations for Kids
                  </h3>
                  <p className="text-gray-600" data-id="element-604">
                    Simple explanations of AI using stories, visuals, and
                    real-life examples.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-2xl border-2 border-[#FC963E]/20 shadow-sm" data-id="element-605">
              <div className="flex items-start gap-4" data-id="element-606">
                <div className="w-12 h-12 bg-[#FC963E]/10 rounded-full flex items-center justify-center shrink-0" data-id="element-607">
                  <Sparkles className="w-6 h-6 text-[#FC963E]" data-id="element-608" />
                </div>
                <div data-id="element-609">
                  <h3 className="text-xl font-bold text-[#1C274C] mb-2" data-id="element-610">
                    Learning Through Play & Creativity
                  </h3>
                  <p className="text-gray-600" data-id="element-611">
                    Interactive activities that spark curiosity, imagination,
                    and problem-solving.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-2xl border-2 border-[#389C70]/20 shadow-sm" data-id="element-612">
              <div className="flex items-start gap-4" data-id="element-613">
                <div className="w-12 h-12 bg-[#389C70]/10 rounded-full flex items-center justify-center shrink-0" data-id="element-614">
                  <Heart className="w-6 h-6 text-[#389C70]" data-id="element-615" />
                </div>
                <div data-id="element-616">
                  <h3 className="text-xl font-bold text-[#1C274C] mb-2" data-id="element-617">
                    Ethical AI Awareness
                  </h3>
                  <p className="text-gray-600" data-id="element-618">
                    Teaching children fairness, responsibility, and safe AI use.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-2xl border-2 border-[#F76874]/20 shadow-sm" data-id="element-619">
              <div className="flex items-start gap-4" data-id="element-620">
                <div className="w-12 h-12 bg-[#F76874]/10 rounded-full flex items-center justify-center shrink-0" data-id="element-621">
                  <CheckCircle className="w-6 h-6 text-[#F76874]" data-id="element-622" />
                </div>
                <div data-id="element-623">
                  <h3 className="text-xl font-bold text-[#1C274C] mb-2" data-id="element-624">
                    Mini Creator Challenges
                  </h3>
                  <p className="text-gray-600" data-id="element-625">
                    Children imagine AI solutions for problems in their schools
                    and communities — focusing on ideas, not complexity.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>

      {/* Who It's For */}
      <Section background="gray" data-id="element-626">
        <div className="max-w-4xl mx-auto text-center" data-id="element-627">
          <h2 className="text-3xl font-bold text-[#1C274C] mb-6" data-id="element-628">
            Who It's For
          </h2>
          <div className="bg-white p-8 rounded-2xl shadow-sm inline-block" data-id="element-629">
            <ul className="text-left space-y-3 text-lg text-gray-700" data-id="element-630">
              <li className="flex items-center" data-id="element-631">
                <CheckCircle className="w-5 h-5 text-[#389C70] mr-3 shrink-0" data-id="element-632" />
                Senior Primary school students
              </li>
              <li className="flex items-center" data-id="element-633">
                <CheckCircle className="w-5 h-5 text-[#389C70] mr-3 shrink-0" data-id="element-634" />
                Secondary school students
              </li>
              <li className="flex items-center" data-id="element-635">
                <CheckCircle className="w-5 h-5 text-[#389C70] mr-3 shrink-0" data-id="element-636" />
                School and community learning groups
              </li>
            </ul>
          </div>
        </div>
      </Section>

      {/* Why It Matters */}
      <Section data-id="element-637">
        <div className="max-w-4xl mx-auto" data-id="element-638">
          <h2 className="text-3xl font-bold text-[#1C274C] mb-6" data-id="element-639">
            Why It Matters
          </h2>
          <p className="text-lg text-gray-600 mb-6" data-id="element-640">
            Early exposure to AI literacy helps children:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-641">
            {['Build confidence around technology', 'Think critically, not passively', 'Develop creativity and innovation skills', 'Grow into ethical digital citizens'].map((item, index) => <div key={index} className="flex items-start bg-[#F2F0E7] p-4 rounded-lg" data-id="element-642">
                <span className="text-[#3AB5E8] mr-3 text-xl" data-id="element-643">✓</span>
                <span className="text-gray-700 font-medium" data-id="element-644">{item}</span>
              </div>)}
          </div>
        </div>
      </Section>

      {/* CTA */}
      <Section className="bg-[#3AB5E8] text-white text-center" data-id="element-645">
        <h2 className="text-3xl font-bold mb-6" data-id="element-646">
          Ready to bring AI education to your school?
        </h2>
        <p className="text-xl mb-8 max-w-2xl mx-auto" data-id="element-647">
          Join our waitlist and be among the first schools to participate in
          Project AI for Kids.
        </p>
        <a href="https://forms.gle/yiZQndnfYhzdQtX68" target="_blank" rel="noopener noreferrer" data-id="element-648">
          <button className="bg-white text-[#3AB5E8] font-extrabold text-lg px-8 py-4 rounded-full shadow-lg hover:bg-gray-50 hover:scale-105 transition-all duration-200 inline-flex items-center gap-2" data-id="element-649">
            Join the Waitlist <ExternalLink className="w-5 h-5" data-id="element-650" />
          </button>
        </a>
      </Section>
    </div>;
};